export const downloadCsv = (data: string, fileName = 'data'): void => {
  const hiddenElement = document.createElement('a');
  hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(data);
  hiddenElement.download = `${fileName}.csv`;
  hiddenElement.click();
};
